import { createSlice } from "@reduxjs/toolkit";
import { users } from "../../../types/user_service";

export const userMgt_getUsers = createSlice({
  name: "users management get users",
  initialState: {
    value: {
      status: false,
      pagination: [] as {
        pagination_data: {
          current_page: number;
          last_page: number;
          per_page: number;
          total: number;
          from: number;
          to: number;
        };
        data: users;
      }[],
      data: [] as users,
    },
  },
  reducers: {
    user_mgt_updateUsers: (state, action) => {
      state.value.status = true;
      state.value.data = action?.payload?.data;
    },
    user_mgt_addUser: (state, action) => {
      const {
        id,
        role_id,
        name,
        email,
        phone_number,
        email_verified_at,
        created_at,
        updated_at,
        institution_id,
        institution,
        deleted_at,
        faculty,
        type,
        role,
        user_type,
        inst_type,
        inst_category,
      } = action?.payload;
      state.value.data = [
        ...state.value.data,
        {
          id,
          role_id,
          name,
          email,
          phone_number,
          email_verified_at,
          created_at,
          updated_at,
          institution_id,
          institution,
          deleted_at,
          faculty,
          type,
          role,
          user_type,
          inst_type,
          inst_category,
        },
      ];
    },
    addToPaginationHistory: (state, action) => {
      state.value.pagination = [
        ...state.value.pagination,
        {
          pagination_data: action?.payload?.pagination_data,
          data: action?.payload?.data,
        },
      ];
    },
    user_mgt_replaceUser: (state, action) => {
      const {
        id,
        role_id,
        name,
        email,
        phone_number,
        email_verified_at,
        created_at,
        updated_at,
        institution_id,
        institution,
        deleted_at,
        faculty,
        type,
        role,
        user_type,
        inst_type,
        inst_category,
      } = action?.payload;
      const currentArray = [...state.value.data];
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => v.id === id
      );

      currentArray.splice(currentIndex, 1, {
        id,
        role_id,
        name,
        email,
        phone_number,
        email_verified_at,
        created_at,
        updated_at,
        institution_id,
        institution,
        deleted_at,
        faculty,
        type,
        role,
        user_type,
        inst_type,
        inst_category,
      });
      state.value.data = currentArray;
    },
    user_mgt_removeUsers: (state, action) => {
      const { id } = action?.payload;
      const currentArray = state.value.data;
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => Number(v.id) === Number(id)
      );
      currentArray.splice(currentIndex, 1);
      state.value.data = currentArray;
    },
    user_mgt_clearUsers: (state) => {
      state.value.status = false;
      state.value.data = [];
    },
  },
});

export const {
  user_mgt_updateUsers,
  user_mgt_addUser,
  addToPaginationHistory,
  user_mgt_replaceUser,
  user_mgt_removeUsers,
  user_mgt_clearUsers,
} = userMgt_getUsers.actions;

export default userMgt_getUsers.reducer;
